module.exports = __webpack_public_path__ + "assets/f80816ef822203b86ded5dd872eaf913.png";